import * as React from 'react';
import {useFormikContext} from 'formik';
import {CourseObject} from 'api/course';
import Row from 'components/Row';
import Column from 'components/Column';
import Input from 'components/Input';
import FormContainer from '../../containers/FormContainer';
import {DatePicker} from "components/DatePicker";
import {DatePickerDateArg} from "components/DatePicker/DatePicker";

/**
 * The general form part of settings
 * @return {React.ReactElement}
 * @constructor
 */
export default function GeneralForm(): React.ReactElement {
  const formContext = useFormikContext<Partial<CourseObject>>();

  /**
   * Render content
   * @return {JSX.Element}
   */
  function renderContent(): JSX.Element {
    /**
     * Render sales dates field
     * @return {JSX.Element}
     */
    function renderSalesDates(): JSX.Element {
      /**
       * Render start date field
       * @return {JSX.Element}
       */
      function renderStartDate(): JSX.Element {
        /**
         * Handle date change
         * @param {DatePickerDateArg} date
         */
        function handleChange(date: DatePickerDateArg): void {
          formContext.setFieldValue('salesDates.startDate', date);
          formContext.submitForm();
        }

        return (
          <Column>
            <Row>
              <Column>
                <DatePicker
                  id="salesDates.startDate"
                  label="Открытие продаж"
                  dateFormat="dd.MM.yyyy в HH:mm"
                  selected={formContext.values.salesDates?.startDate}
                  showTimeSelect
                  onChange={handleChange}
                  required
                />
              </Column>
            </Row>
          </Column>
        );
      }

      /**
       * Render over date field
       * @return {JSX.Element}
       */
      function renderOverDate(): JSX.Element {
        /**
         * Handle date change
         * @param {DatePickerDateArg} date
         */
        function handleChange(date: DatePickerDateArg): void {
          formContext.setFieldValue('salesDates.overDate', date);
          formContext.submitForm();
        }

        return (
          <Column>
            <Row>
              <Column>
                <DatePicker
                  id="salesDates.overDate"
                  label="Закрытие продаж"
                  dateFormat="dd.MM.yyyy в HH:mm"
                  selected={formContext.values.salesDates?.overDate}
                  showTimeSelect
                  onChange={handleChange}
                />
              </Column>
            </Row>
          </Column>
        );
      }

      return (
        <Row>
          {renderStartDate()}
          {renderOverDate()}
        </Row>
      );
    }

    /**
     * Render chat link field
     * @return {JSX.Element}
     */
    function renderChatLink(): JSX.Element {
      /**
       * Handle input blur
       * @param {React.FocusEvent<HTMLInputElement>} event
       */
      function handleBlur(event: React.FocusEvent<HTMLInputElement>): void {
        formContext.setFieldValue('chatLink', event.target.value);
        formContext.submitForm();
      }

      return (
        <Row>
          <Column>
            <Row>
              <Column>
                <Input
                  type="text"
                  defaultValue={formContext.values.chatLink}
                  label="Ссылка на групповой чат"
                  placeholder="Укажите ссылку на чат"
                  onBlur={handleBlur}
                />
              </Column>
            </Row>
          </Column>
        </Row>
      );
    }

    return (
      <React.Fragment>
        {renderSalesDates()}
        {renderChatLink()}
      </React.Fragment>
    );
  }

  return (
    <FormContainer>
      {renderContent()}
    </FormContainer>
  );
}
